<template>
  <div class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
    <div class="md:grid md:grid-cols-3 md:gap-6">
      <div class="md:col-span-1" v-if="title">
        <h3 class="text-lg font-medium leading-6 text-gray-900">{{ title }}</h3>
        <p class="mt-1 text-sm leading-5 text-gray-500" v-html="subtitle"></p>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div class="grid grid-cols-6 gap-6 items-end">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "form-section",
  props: {
    title: String,
    subtitle: String
  },

  data: function() {
    return {};
  },

  computed: {},
  methods: {}
};
</script>